import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { SharedService } from 'src/services/sharedservice/shared.service.service';

@Injectable()

export class InterceptorInterceptor implements HttpInterceptor {

  private readonly SKIP_URLS = [
    '/confirm-email',
    '/password-forgot',
    '/verify-otp',
    '/verify-email-otp',
    '/reset-password',
    '/confirm-email-username',
    '/login',
  ];

  constructor(
    private router: Router,
    private sharedService: SharedService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.shouldSkip(request.url)) {
      return next.handle(request);
    }

    const token = sessionStorage.getItem('access_token');

    if (!token) {
      this.router.navigateByUrl('/login');
      return next.handle(request);
    }

    const slug = this.getCurrentRouteSlug();
    const moduleInfo = this.getModuleBySlug(slug);

    const modifiedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ...(moduleInfo
          ? {
              moduleId: moduleInfo.id,
              moduleType: moduleInfo.type, // 👈 NEW KEY
            }
          : {}),
      },
    });

    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigateByUrl('/login');
        }
        return throwError(() => error);
      }),
    );
  }

  private getCurrentRouteSlug(): string | null {
    let route = this.router.routerState.snapshot.root;
   
    while (route.firstChild) {
      route = route.firstChild;
    }
    while (route) {
      const slug = route.data?.['slug'];
      if (slug) {
        return slug;
      }
      route = route.parent!;
    }

    return null;
  }

  private getModuleBySlug(slug: string | null): { id: string; type: 'modules' | 'submodules' } | null {
    if (!slug) return null;

    const permissions = this.sharedService.getUserPermissions() || [];
  
    for (const module of permissions) {
      if (module.moduleSlug === slug) {
        return {
          id: module?.id || module?._id,
          type: 'modules',
        };
      }

      if (module.subModules?.length) {
        const sub = module.subModules.find((s: any) => s.moduleSlug === slug);

        if (sub) {
          return {
            id: sub?.id || sub?._id,
            type: 'submodules',
          };
        }
      }
    }

    return null;
  }

  private shouldSkip(url: string): boolean {
    return this.SKIP_URLS.some((skip) => url.includes(skip));
  }
}